export function formatPlannerCoordinates(coordinate) {
  if (coordinate && coordinate.lat !== undefined && coordinate.lng !== undefined) {
    return `${coordinate.lat},${coordinate.lng}`
  }
  return ''
}

export function getEffectivePlannerPosition(
  userPosition,
  municipalityPosition,
  runtimePosition
) {
  return userPosition || municipalityPosition || runtimePosition || null
}

export function buildGooglePlaceDirectionUpdate(fieldName, place) {
  const coordinates = `${place.geometry.location.lat()},${place.geometry.location.lng()}`

  return {
    directionField: fieldName,
    direction: `${place.formatted_address}`,
    coordinatesField: fieldName === 'originDirection' ? 'originCoordinates' : 'destinationCoordinates',
    coordinates
  }
}

export function buildSelectedLocationUpdate(location, activeField, myPositionLabel, userPosition) {
  const isOrigin = activeField === 'origin'
  const isUserPosition = location.name === myPositionLabel
  const directionField = isOrigin ? 'originDirection' : 'destinationDirection'
  const coordinatesField = isOrigin ? 'originCoordinates' : 'destinationCoordinates'
  const recentSearchFieldType = isOrigin ? 'origin' : 'destination'

  if (isUserPosition) {
    return {
      directionField,
      coordinatesField,
      direction: myPositionLabel,
      coordinates: `${userPosition.lat},${userPosition.lng}`,
      recentSearchFieldType
    }
  }

  return {
    directionField,
    coordinatesField,
    direction: location.name,
    coordinates: `${location.coordinates[1]},${location.coordinates[0]}`,
    recentSearchFieldType
  }
}

export function swapPlannerDirections(state, coordinatesMode) {
  const originDirection = state.originDirection ? JSON.parse(JSON.stringify(state.originDirection)) : null
  const destinationDirection = state.destinationDirection ? JSON.parse(JSON.stringify(state.destinationDirection)) : null
  const originCoordinates = state.originCoordinates ? JSON.parse(JSON.stringify(state.originCoordinates)) : null
  const destinationCoordinates = state.destinationCoordinates ? JSON.parse(JSON.stringify(state.destinationCoordinates)) : null
  const shouldSwapModes = state.originMode === coordinatesMode || state.destinationMode === coordinatesMode

  return {
    originDirection: destinationDirection,
    destinationDirection: originDirection,
    originCoordinates: destinationCoordinates,
    destinationCoordinates: originCoordinates,
    originMode: shouldSwapModes ? state.destinationMode : state.originMode,
    destinationMode: shouldSwapModes ? state.originMode : state.destinationMode
  }
}
